import { apiSlice } from "../../api/apiSlice";

// CONSTANTS
const FEATURES_URL = "api/features";
const SERVICES_URL = "api/services";
const BUSINESS_CARDS_URL = "api/get_all_business_cards";
const SETTINGS_URL = "api/settings";
const CONTACT_URL = "api/contactus";

// ################### HOME API SLICE ###################
export const homeApiSlice = apiSlice.injectEndpoints({
   endpoints: (builder) => ({
      getFeatures: builder.query({
         query: () => FEATURES_URL,
      }),
      getServices: builder.query({
         query: () => SERVICES_URL,
      }),
      getBusinessCards: builder.query({
         query: () => BUSINESS_CARDS_URL,
      }),
      getSettings: builder.query({
         query: () => SETTINGS_URL,
      }),
      contactUsMsg: builder.mutation({
         query: (msg) => {
            return {
               url: CONTACT_URL,
               method: "POST",
               body: msg,
               formData: true,
            };
         },
      }),
   }),
});

export const {
   useGetFeaturesQuery,
   useGetServicesQuery,
   useGetBusinessCardsQuery,
   useGetSettingsQuery,
   useContactUsMsgMutation,
} = homeApiSlice;
